import { Toasts } from '../../components/toaster/Toast'

// MER-3680: the shared axios handler hides every 409, so each recipe enable caller
// shows this refusal itself.
export const toastUpgradedToV2Refusal = (err: any): boolean => {
    const data = err?.response?.data
    if (err?.response?.status !== 409 || data?.code !== 'recipe_upgraded_to_v2') {
        return false
    }
    Toasts.error(data.message)
    return true
}
